import React, { useMemo } from 'react';
import PaperFireworks from '@src/assets/images/paper-fireworks.svg';
import Typography from '@src/new-components/Typography';
import actions from '@src/redux/actions';
import { useMediaQuery } from '@mui/material';
import theme from '@src/styles/theme';
import { CODES } from '@src/constants/tasks';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { useDispatch, useSelector } from 'react-redux';
import AlertMessage from '@src/new-components/AlertMessage';
import ActionDialog from '@src/new-components/Dialog/ActionDialog';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import CommonButton from '@src/new-components/Button';
import {
  StyledTaskCompleted,
  StyledTaskContentLeft,
  StyledTaskContentRight,
  StyledTaskTitle,
} from './index.styled';

const ICON_SIZE = { width: '24px', height: '24px' };
const COMPLETED_ICON_STYLE = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px',
  boxSizing: 'border-box',
  borderRadius: '50%',
  width: '32px',
  height: '32px',
};

const PopupCompleteTask = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { language } = i18n;
  const { taskCompletedData, showCompleteTaskSurveyDialog } = useSelector(
    (state) => state.layout,
  );

  const rewardCredits = useMemo(
    () =>
      taskCompletedData?.rewards?.reduce((sum, { details, type }) => {
        if (type === 'CREDIT') {
          return sum + (details?.amount || 0);
        }
        return sum;
      }, 0) || 0,
    [taskCompletedData?.rewards],
  );

  if (
    taskCompletedData?.code === CODES.COMPLETE_ONBOARDING_SURVEY &&
    showCompleteTaskSurveyDialog
  ) {
    return null;
  }

  return (
    <>
      <ActionDialog
        open={open}
        title={t('completeTask')}
        styleTitle={{
          textAlign: 'center',
        }}
        showBlurBackground
        paddingMobile="16px"
        marginMobile="16px"
        contentComponent={
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
          >
            <StyledTaskCompleted>
              <StyledTaskContentLeft>
                {isMobile ? (
                  <div style={COMPLETED_ICON_STYLE}>
                    <CheckCircleRoundedIcon
                      sx={{ ...ICON_SIZE, color: COLOR.green }}
                    />
                  </div>
                ) : (
                  <img src={taskCompletedData?.icon} alt="task-icon" />
                )}
                <StyledTaskTitle>
                  <Typography
                    className="title-task"
                    variant="body-16-medium"
                    color={COLOR.darkGray}
                  >
                    {taskCompletedData?.title?.[language]}
                  </Typography>
                  <div
                    className="bonus-credits-mobile"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: t('bonusCredit', {
                        credits: rewardCredits?.toLocaleString(language),
                      }),
                    }}
                  />
                </StyledTaskTitle>
              </StyledTaskContentLeft>
              <StyledTaskContentRight>
                <div
                  className="bonus-credits"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: t('bonusCredit', {
                      credits: rewardCredits?.toLocaleString(language),
                    }),
                  }}
                />
                {!isMobile && (
                  <div style={COMPLETED_ICON_STYLE}>
                    <CheckCircleRoundedIcon
                      sx={{ ...ICON_SIZE, color: COLOR.green }}
                    />
                  </div>
                )}
              </StyledTaskContentRight>
            </StyledTaskCompleted>
            <AlertMessage
              type="info"
              startIcon={
                <InfoRoundedIcon
                  sx={{ color: COLOR.textPending, fontSize: '20px' }}
                />
              }
              styleWrapper={{
                gap: '0px !important',
              }}
              style={{
                padding: '8px 16px',
                height: '56px',
                boxSizing: 'border-box',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography
                variant="body-14-regular"
                color={COLOR.descriptionGray}
              >
                {t('rewardFromReferralCodeInfo')}
              </Typography>
            </AlertMessage>
          </div>
        }
        fullWidth
        image={PaperFireworks}
        imageContainerSize="80px"
        onClose={onClose}
        width="568px"
        widthContent="100%"
        height="372px"
        actionComponent={
          <CommonButton
            variant="contained"
            onClick={() => {
              onClose();
              if (isMobile) {
                dispatch(actions.layout.setShowOnboardingPopupMobile(true));
              } else {
                dispatch(actions.layout.setShowOnboardingPopup(true));
              }
            }}
            textProps={{
              variantText: 'body-14-semibold',
              color: COLOR.darkBlue,
            }}
            className="action-button"
            customStyle={{
              height: '40px',
              borderRadius: '8px',
              padding: '8px 24px',
              width: '105px',
            }}
          >
            {t('continueTask')}
          </CommonButton>
        }
      />
    </>
  );
};

export default PopupCompleteTask;
